'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.statementsToExpression = statementsToExpression;
exports.toBlockStatement = toBlockStatement;
exports.toStatement = toStatement;
exports.toFunctionBody = toFunctionBody;
exports.ensureBlockBody = ensureBlockBody;
exports.blockToExpression = blockToExpression;
exports.getScopeParent = getScopeParent;
exports.iife = iife;

var _types = require('../types');

var _types2 = _interopRequireDefault(_types);

var _astLocUtils = require('ast-loc-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// c/p https://github.com/babel/babel/blob/master/packages/babel-types/src/converters.js
// Helpers for transforming blocks of code.
function gatherSequenceExpressions(nodes) {
  var exprs = [];
  var ensureLastNull = true;

  // TODO: comprehension
  for (var _i2 = 0, _len2 = nodes.length; _i2 < _len2; _i2++) {
    var _node = nodes[_i2];
    ensureLastNull = false;

    if ((0, _types.isa)(_node, "Expression")) {
      exprs.push(_node);
    } else if ((0, _types.isa)(_node, "ExpressionStatement")) {
      exprs.push(_node.expression);
    } else if ((0, _types.isa)(_node, "IfStatement")) {
      var _consequent = _node.consequent,
          _alternate = _node.alternate,
          _test = _node.test;

      var cq = _consequent; // XXX: https://github.com/lightscript/lightscript/issues/39
      var alt = _alternate; // XXX: https://github.com/lightscript/lightscript/issues/39
      if (!cq) return;
      var nextCq = gatherSequenceExpressions([cq]);
      var nextAlt = alt ? gatherSequenceExpressions([alt]) : (0, _astLocUtils.placeAtNode)(_types2.default.unaryExpression("void", (0, _astLocUtils.placeAtNode)(_types2.default.numericLiteral(0), cq), true), cq);
      if (!nextCq || !nextAlt) return;

      var loc = (0, _astLocUtils.getSurroundingLoc)([_test, nextCq, nextAlt]);
      exprs.push((0, _astLocUtils.placeAtLoc)(_types2.default.conditionalExpression(_test, nextCq, nextAlt), loc));
    } else if ((0, _types.isa)(_node, "BlockStatement")) {
      var body = gatherSequenceExpressions(_node.body);
      if (!body) return;
      exprs.push(body);
    } else if ((0, _types.isa)(_node, "EmptyStatement")) {
      ensureLastNull = true;
    } else {
      return;
    }
  }if (ensureLastNull) {
    exprs.push((0, _astLocUtils.placeAtNode)(_types2.default.nullLiteral(), exprs[exprs.length - 1]));
  } // TODO: sourcemap
  if (exprs.length === 1) return exprs[0];else return _types2.default.sequenceExpression(exprs);
}function toSequenceExpression(nodes) {
  if (!nodes || !nodes.length) return;
  return gatherSequenceExpressions(nodes);
} // c/p https://github.com/babel/babel/blob/1e55653ac173c3a59f403a7b5269cf6d143d32d9/packages/babel-traverse/src/path/replacement.js
function statementsToExpression(path, nodes) {
  path.resync();

  var seqExpr = toSequenceExpression(nodes);

  if ((0, _types.isa)(seqExpr, "SequenceExpression")) {
    var exprs = seqExpr.expressions;
    if (exprs.length === 1) return exprs[0];else return seqExpr;
  } else if (seqExpr) {
    return seqExpr;
  } else {
    return iife(nodes);
  }
} // Wrap a node in a BlockStatement container.
function toBlockStatement(body) {
  var bodyLoc = (0, _astLocUtils.getLoc)(body);

  if ((0, _types.isa)(body, "BlockStatement")) {
    return body;
  } else if ((0, _types.isa)(body, "Statement")) {
    return (0, _astLocUtils.placeAtLoc)(_types2.default.blockStatement([body]), bodyLoc);
  } else {
    return (0, _astLocUtils.placeAtLoc)(_types2.default.blockStatement([(0, _astLocUtils.placeAtLoc)(_types2.default.expressionStatement(body), bodyLoc)]), bodyLoc);
  }
} // Wrap expressions in an ExpressionStatement container.
function toStatement(body) {
  if ((0, _types.isa)(body, "Expression")) {
    return (0, _astLocUtils.placeAtNode)(_types2.default.expressionStatement(body), body);
  } else {
    return body;
  }
} // Convert a node to appropriate form to be a Function body.
function toFunctionBody(body) {
  if ((0, _types.isa)(body, "Expression")) {
    return body;
  } else {
    return toBlockStatement(body);
  }
} // Transform the AST so that the function at the given path has a block body.
function ensureBlockBody(path) {
  if (!(0, _types.isa)(path.node.body, "BlockStatement")) {
    return path.get("body").replaceWith((0, _astLocUtils.buildAtLoc)((0, _astLocUtils.getLoc)(path.node.body), _types2.default.blockStatement, [path.node.body]));
  }
} // Obtain an expression equivalent to the block at the given path. In the worst
// case, the block is wrapped in an IIFE.
function blockToExpression(path) {
  var node = path.node;

  if ((0, _types.isa)(node, "BlockStatement")) {
    return statementsToExpression(path, path.node.body);
  } else if ((0, _types.isa)(node, "FunctionDeclaration")) {
    // Special case: the parser promotes a block consisting of a single declaration
    // from ExprStatement(FunctionExpr) to FunctionDeclaration. Convert back to
    // expression here.
    var nextNode = _types2.default.clone(node);
    if (nextNode.type === "NamedArrowDeclaration") {
      nextNode.type = "NamedArrowExpression";
    } else {
      nextNode.type = "FunctionExpression";
    }return nextNode;
  } else if ((0, _types.isa)(node, "ExpressionStatement")) {
    return node.expression;
  } else {
    return node;
  }
} // Locate the path that determines the variable scope at the given path.
function getScopeParent(path) {
  return path.findParent(function (path) {
    return path.isFunction() || path.isBlockStatement() || path.isProgram();
  });
}function iife(body) {
  var async = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var actualBody = Array.isArray(body) ? function () {
    var bodyLoc = (0, _astLocUtils.getSurroundingLoc)(body);
    return (0, _astLocUtils.placeAtLoc)(_types2.default.blockStatement(body), bodyLoc);
  }() : toBlockStatement(body);

  var loc = (0, _astLocUtils.getLoc)(actualBody);

  return (0, _astLocUtils.placeAtLoc)(_types2.default.callExpression((0, _astLocUtils.placeAtLoc)(_types2.default.arrowFunctionExpression([], actualBody, async), loc), []), loc);
}